const type = 'CLOSE_CARD_STATUS_CHANGE';

const closeCardStatusChange = () => ({
  type,
});

export { type };
export default closeCardStatusChange;
